import { apiCreate, apiDelete, apiGetOne } from './ApiBaseActions';
export const API_GET_LIST_PROFESSIONAL_SEMINAR_SELF = 'API_GET_LIST_PROFESSIONAL_SEMINAR_SELF';
export const API_GET_LIST_PROFESSIONAL_SEMINAR_SELF_SUCCESS = 'API_GET_LIST_PROFESSIONAL_SEMINAR_SELF_SUCCESS';
export const API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION = 'API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION';
export const API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION_SUCCESS = 'API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION_SUCCESS';
export const API_GET_ONE_PROFESSIONAL_SEMINAR_ONE = 'API_GET_ONE_PROFESSIONAL_SEMINAR_ONE';
export const API_GET_ONE_PROFESSIONAL_SEMINAR_ONE_SUCCESS = 'API_GET_ONE_PROFESSIONAL_SEMINAR_ONE_SUCCESS';
export const API_CREATE_PROFESSIONAL_SEMINAR = 'API_CREATE_PROFESSIONAL_SEMINAR';
export const API_CREATE_PROFESSIONAL_SEMINAR_CLONE = 'API_CREATE_PROFESSIONAL_SEMINAR_CLONE';
export const API_UPDATE_PROFESSIONAL_SEMINAR = 'API_UPDATE_PROFESSIONAL_SEMINAR';
export const API_DELETE_PROFESSIONAL_SEMINAR = 'API_DELETE_PROFESSIONAL_SEMINAR';
/**
 * 自身が作成したセミナーを取得
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProfessionalSeminarSelf = (params, meta) => apiCreate(API_GET_LIST_PROFESSIONAL_SEMINAR_SELF, '/seminar/self', params, Object.assign(Object.assign({}, params), meta));
/**
 * 自身と同じ組織に属する他のコンサルタントが作成したセミナーを取得
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProfessionalSeminarOrganization = (params, meta) => apiCreate(API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION, '/seminar/organization', params, Object.assign(Object.assign({}, params), meta));
/**
 * セミナーの取得
 * @param id
 * @param meta
 * @returns {*}
 */
export const apiGetOneProfessionalSeminar = (id, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL_SEMINAR_ONE, `/seminar/${id}/edit`, Object.assign({}, meta));
/**
 * セミナーの作成
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiCreateProfessionalSeminar = (params, meta) => apiCreate(API_CREATE_PROFESSIONAL_SEMINAR, '/seminar/create', params, Object.assign(Object.assign({}, params), meta));
/**
 * セミナーの複製
 * @param id
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiCreateProfessionalSeminarClone = (id, params, meta) => apiCreate(API_CREATE_PROFESSIONAL_SEMINAR_CLONE, `/seminar/${id}/clone`, params, Object.assign(Object.assign({}, params), meta));
/**
 * セミナーの作成
 * @param id
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiUpdateProfessionalSeminar = (id, params, meta) => apiCreate(API_UPDATE_PROFESSIONAL_SEMINAR, `/seminar/${id}/update`, params, Object.assign(Object.assign({}, params), meta));
/**
 * セミナーの削除
 * @param id
 * @param meta
 * @returns {*}
 */
export const apiDeleteProfessionalSeminar = (id, meta) => apiDelete(API_DELETE_PROFESSIONAL_SEMINAR, `/seminar/${id}/delete`, Object.assign({}, meta));
